import { FC } from "react";
import InputRadio from "../atoms/InputRadio";
import LabelSelector from "../atoms/LabelForInputRadio";

type InputRadioGroupProps = {
  id: string;
  name: string;
  text: string;
  value?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
const InputRadioGroup: FC<InputRadioGroupProps> = ({ id, name, text, value, checked, onChange }) => {
  return (
    <div className="flex items-center">
      <InputRadio id={id} name={name} value={value} checked={checked} onChange={onChange}/>
      <LabelSelector id={id} text={text} />
    </div>
  );
};

export default InputRadioGroup;
